export default {
  methods: {
    toggleColumnMenu () {
      if (this.$refs.menu) { this.$refs.menu.classList.toggle('hide') }
    },
    hideColumnMenu () {
      if (this.$refs.menu && !this.$refs.menu.classList.contains('hide')) { this.$refs.menu.classList.add('hide') }
    }
  }
}
